import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsPowerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_power"}/>
}
